<template>
	<DashboardCardCollapsible :heading :sub-heading>
		<template #icons>
			<AppButton
				v-if="actions.remove"
				variant="ghost"
				type="button"
				:icon="actions.remove.icon"
				:disabled="actions.remove.disabled"
				:title="actions.remove.label"
				:aria-label="actions.remove.label"
				@click="actions.remove.execute"
			/>
			<AppButton
				v-if="actions.add"
				variant="ghost"
				type="button"
				:icon="actions.add.icon"
				:disabled="actions.add.disabled"
				:title="actions.add.label"
				:aria-label="actions.add.label"
				@click="actions.add.execute"
			/>
		</template>
		<slot></slot>
	</DashboardCardCollapsible>
</template>

<script lang="ts" setup>
interface Action {
	icon: string;
	label: string;
	execute: () => void;
	disabled: boolean;
}

interface Props {
	actions: {
		add?: Action;
		remove?: Action;
	};
	heading?: string;
	subHeading?: string;
}
defineProps<Props>();
</script>
